import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";
import GaHelper from "lib/gaHelper";
import config from "lib/fr-config";

const UNIT_LENGTH = config.outfitList.LENGTH;
const EXP_MINUTE = 30;

const ADD_OUTFIT_LIST = "followingsOutfit/ADD_OUTFIT_LIST";
const SET_EXPIRATION_DATE = "followingsOutfit/SET_EXPIRATION_DATE";
const CHECK_IS_END = "followingsOutfit/CHECK_IS_END";
const SET_IS_LOADING = "followingsOutfit/SET_IS_LOADING";
const INIT_MUTABLE_DATA = "followingsOutfit/INIT_MUTABLE_DATA";
const INIT_ALL_DATA = "followingsOutfit/INIT_ALL_DATA";

const addOutfitList = createAction(ADD_OUTFIT_LIST);
const setExpirationDate = createAction(SET_EXPIRATION_DATE);
const checkIsEnd = createAction(CHECK_IS_END);
const setIsLoading = createAction(SET_IS_LOADING);
const initMutableData = createAction(INIT_MUTABLE_DATA);
const initAllData = createAction(INIT_ALL_DATA);

const getFollowingsOutfitState = ({ getState }) => {
  const followingsOutfitState = getState().followingsOutfit.toJS();
  return followingsOutfitState;
};

const getIsLoading = ({ getState }) => {
  const followingsOutfitState = getFollowingsOutfitState({ getState });
  const { isLoading } = followingsOutfitState;
  return isLoading;
};

const getLastHash = list => {
  if (list.length === 0) return undefined;
  const length = list.length;
  return list[length - 1]["outfitHash"];
};

const requestFollowList = async ({ outfitList, idToken }) => {
  const length = UNIT_LENGTH;
  const lastHash = getLastHash(outfitList);
  const { code, res, errInfo } = await Restful.getOutfitOfMyFollowingsAPI({
    idToken,
    lastHash,
    length
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    return { list: res.list };
  }
};

const checkExpDate = ({ getState }) => {
  const followingsOutfitState = getFollowingsOutfitState({ getState });
  const { expirationDate } = followingsOutfitState;
  if (!expirationDate) return { needUpdate: true };
  const nowDate = new Date();
  return { needUpdate: nowDate > expirationDate ? true : false };
};

const setExpDate = ({ dispatch }) => {
  const expirationDate = new Date();
  expirationDate.setMinutes(expirationDate.getMinutes() + EXP_MINUTE);
  dispatch(setExpirationDate(expirationDate));
};

const concatFollowingOutfitList = async ({ getState, dispatch, idToken }) => {
  const followingsOutfitState = getFollowingsOutfitState({ getState });
  const { outfitList } = followingsOutfitState;
  const { list } = await requestFollowList({ outfitList, idToken });
  dispatch(addOutfitList(outfitList.concat(list)));
  dispatch(checkIsEnd(list.length));
  GaHelper.setGARequestOutfitListEvent({
    type: "followingsOutfitList",
    pageNum: outfitList.length / UNIT_LENGTH + 1
  });
};

export const initList = idToken => async (dispatch, getState) => {
  const isLoading = getIsLoading({ getState });
  if (isLoading) return null;

  dispatch(setIsLoading(true));

  const { needUpdate } = checkExpDate({ getState });

  if (needUpdate) {
    dispatch(initMutableData());
    await concatFollowingOutfitList({ getState, dispatch, idToken });
    setExpDate({ dispatch });
  }
  dispatch(setIsLoading(false));
};

export const requestNextList = idToken => async (dispatch, getState) => {
  const followingsOutfitState = getFollowingsOutfitState({ getState });
  const { isEnd } = followingsOutfitState;
  const isLoading = getIsLoading({ getState });

  if (isLoading || isEnd) return null;

  dispatch(setIsLoading(true));
  await concatFollowingOutfitList({ getState, dispatch, idToken });
  dispatch(setIsLoading(false));
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  outfitList: [],
  expirationDate: null,
  isEnd: false,
  isLoading: false
});

export default handleActions(
  {
    [ADD_OUTFIT_LIST]: (state, action) => {
      const outfitList = action.payload;
      return state.set("outfitList", fromJS(outfitList));
    },
    [SET_EXPIRATION_DATE]: (state, action) => {
      const expirationDate = action.payload;
      return state.set("expirationDate", fromJS(expirationDate));
    },
    [CHECK_IS_END]: (state, action) => {
      const length = action.payload;
      const isEnd = length === UNIT_LENGTH ? false : true;
      return state.set("isEnd", fromJS(isEnd));
    },
    [SET_IS_LOADING]: (state, action) => {
      const isLoading = action.payload;
      return state.set("isLoading", fromJS(isLoading));
    },
    [INIT_MUTABLE_DATA]: (state, action) => {
      const { outfitList, expirationDate, isEnd } = initialState.toJS();
      return state
        .set("outfitList", fromJS(outfitList))
        .set("expirationDate", fromJS(expirationDate))
        .set("isEnd", fromJS(isEnd));
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
